import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getWorkbookTemplateQueryV2,
  getWorkbookTemplateFolderQuery,
  getWorkbookSchoolTemplateQuery,
  getWorkbookSchoolTemplatesCountQuery,
} from "./WorkbookTemplateQueries";
import {
  getWorkbookTemplateQuery,
  getWorkbookTemplateFolderQueryV2,
  getWorkbookSchoolTemplateQueryV2,
  getWorkbookSchoolTemplatesCountQueryV2,
} from "./WorkbookTemplateQueriesV2";
import { createAttachmentMutation } from "./WorkbookTemplateMutations";
import { isExcludedParentTypesForAttachmentCache } from "modules/Services";
import {
  getAttachmentOfNodeFromCache,
  writeAttachmentNodeFragment,
} from "modules/CommonGraphqlHelpers";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { isNewTemplateResolverEnabled } from "./Utils";
export const getWorkbookTemplatesFromCache = ({
  id,
  organizationId,
  types,
  searchText,
  first,
  states,
  courseIds,
  createdBy,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: isNewTemplateResolverEnabled()
        ? getWorkbookTemplateQuery
        : getWorkbookTemplateQueryV2,
      variables: {
        ...(isNewTemplateResolverEnabled() ? { organizationId } : { id }),
        types,
        searchText,
        first,
        states,
        courseIds,
        createdBy,
      },
    });
  } catch (e) {}
  return queryData;
};
export const getWorkbookTemplatesFolderFromCache = ({
  types,
  searchText,
  id,
  first,
  states,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: isNewTemplateResolverEnabled()
        ? getWorkbookTemplateFolderQueryV2
        : getWorkbookTemplateFolderQuery,
      variables: { types, searchText, id, first, states },
    });
  } catch (e) {}
  return queryData;
};

export const getWorkbookSchoolTemplateFromCache = templateFolderFilters => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: isNewTemplateResolverEnabled()
        ? getWorkbookSchoolTemplateQueryV2
        : getWorkbookSchoolTemplateQuery,
      variables: { ...templateFolderFilters },
    });
  } catch (e) {}
  return queryData;
};

export const writeWorkbookSchoolTemplateFromCache = ({ filters, data }) => {
  try {
    client.writeQuery({
      query: isNewTemplateResolverEnabled()
        ? getWorkbookSchoolTemplateQueryV2
        : getWorkbookSchoolTemplateQuery,
      variables: filters,
      data: data,
    });
  } catch (e) {}
};

export const writeWorkbookSchoolTemplateCounToCache = ({ filters, data }) => {
  const { organizationId, curriculumProgramId } = filters;
  try {
    client.writeQuery({
      query: isNewTemplateResolverEnabled()
        ? getWorkbookSchoolTemplatesCountQueryV2
        : getWorkbookSchoolTemplatesCountQuery,
      variables: {
        types: ["WORKBOOK_TEMPLATE"],
        organizationId,
        curriculumProgramId,
      },
      data: data,
    });
  } catch (e) {}
};

export const getWorkbookSchoolTemplateCountFromCache = ({
  organizationId,
  curriculumProgramId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: isNewTemplateResolverEnabled()
        ? getWorkbookSchoolTemplatesCountQueryV2
        : getWorkbookSchoolTemplatesCountQuery,
      variables: {
        types: ["WORKBOOK_TEMPLATE"],
        organizationId,
        curriculumProgramId,
      },
    });
  } catch (e) {}
  return queryData;
};

export const createAttachment = ({
  nodeId,
  attachment,
  type,
  parentType,
  portalType,
  lockingState,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo({ portalType });
    const userId = userInfo.id;

    try {
      const response = await client.mutate({
        mutation: createAttachmentMutation,
        variables: {
          name: attachment.name,
          url: attachment.url,
          type: attachment.type,
          thumbUrl: attachment.thumbUrl ? attachment.thumbUrl : "",
          mimeType: attachment.mimeType,
          createdBy: userId,
          parentId: nodeId,
          parentType: parentType,
          metadata: attachment.metadata,
          portalType,
          lockingState,
          presetAttachmentId: attachment.presetAttachmentId,
        },

        update: (
          cache,
          {
            data: {
              platform: { createAttachment },
            },
          }
        ) => {
          if (!isExcludedParentTypesForAttachmentCache({ parentType: type })) {
            const nodeDetails = getAttachmentOfNodeFromCache({ nodeId, type });
            const attachments = _.get(nodeDetails, "attachments", [])
              ? _.get(nodeDetails, "attachments", [])
              : [];

            const data = {
              ...nodeDetails,
              attachments: [...attachments, ...createAttachment],
            };

            writeAttachmentNodeFragment({
              nodeId,
              data,
              type,
            });
          }
        },
      });
      return _.get(response, "data.platform.createAttachment", []);
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return [];
    }
  };
};
